import { Validators } from '@angular/forms';
import { ControlStringProperty } from '../../../../common/models';

export class AddressExtIdsModel {
  extId: string;
  source: string;
  constructor(params?: AddressExtIdsModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AddressExtIdsForm {
  constructor(
    extIdModel: AddressExtIdsModel,
    hasUpdatePermission: boolean = true,
    public extId: ControlStringProperty = [
      { value: extIdModel.extId, disabled: !hasUpdatePermission },
      [Validators.required],
    ],
    public source: ControlStringProperty = [
      { value: extIdModel.source, disabled: !hasUpdatePermission },
      [Validators.required],
    ],
  ) {}
}
